(function () {
  // ─── CONFIG ───────────────────────────────────────────────────────────────
  // Driven by window.__skioActivePlatform injected in theme.liquid.
  // Set to 'appstle' before launch, 'skio' after launch.
  var ACTIVE_PLATFORM = window.__skioActivePlatform || 'appstle';

  // ─────────────────────────────────────────────────────────────────────────

  var groups      = window.__sellingPlanGroups || [];
  var activeAppId = ACTIVE_PLATFORM.toLowerCase();

  // Build the set of allowed selling plan IDs for the active platform.
  var allowed = new Set();
  groups.forEach(function (group) {
    var groupAppId = (group.app_id || '').toLowerCase();
    if (groupAppId === activeAppId) {
      (group.selling_plans || []).forEach(function (plan) {
        allowed.add(String(plan.id));
      });
    }
  });

  // If no allowed plans found, app_id didn't match — bail out so we don't
  // accidentally hide everything.
  if (allowed.size === 0) return;

  function filterSelect(select) {
    if (select.dataset.skioFiltered) return;
    select.dataset.skioFiltered = 'true';

    var changed = false;
    Array.from(select.options).forEach(function (opt) {
      if (!allowed.has(opt.value)) {
        opt.remove();
        changed = true;
      }
    });

    if (!changed) return;

    if (select.options.length === 0) {
      // No allowed plans remain — hide the entire subscription widget.
      var widget = select.closest('.kaching-bundles__subscriptions');
      if (widget) widget.style.display = 'none';
    } else {
      // Sync Kaching's hidden input by firing a change event on the select.
      select.selectedIndex = 0;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Initial pass — Kaching may already be rendered by the time this script runs.
  document.querySelectorAll('select.kaching-bundles__selling-plan-select')
    .forEach(filterSelect);

  // Watch for Kaching rendering async after page load.
  var observer = new MutationObserver(function () {
    document.querySelectorAll(
      'select.kaching-bundles__selling-plan-select:not([data-skio-filtered])'
    ).forEach(filterSelect);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
